import React, { useState, useEffect } from 'react';
import {
  Box,
} from '@mui/material';
import { MdEdit } from 'react-icons/md';
import { confirmWrapper } from 'src/components/Dialog';
import EditorInline from 'src/components/elements/Editor/Inline';
import {
  CloseActiveIcon,
  CloseSquareIcon,
  ConfirmActiveIcon,
  ConfirmSquareIcon,
} from 'src/icons';

const Description = function (props: any) {
  const {
    value = '',
    confirmFunction,
  } = props;

  const [tempValue, setTempValue] = useState(value);
  const [newValue, setNewValue] = useState(value);
  const [editMode, togleEditMode] = useState(false);

  const [isCloseHovered, setIsCloseHovered] = useState(false);
  const [isConfirmHovered, setIsConfirmHovered] = useState(false);

  const handleMouseEnterClose = () => {
    setIsCloseHovered(true);
  };

  const handleMouseLeaveClose = () => {
    setIsCloseHovered(false);
  };

  const handleMouseEnterConfirm = () => {
    setIsConfirmHovered(true);
  };

  const handleMouseLeaveConfirm = () => {
    setIsConfirmHovered(false);
  };

  useEffect(() => {
    setNewValue(value);
    setTempValue('');
    togleEditMode(false);
  }, [value]);

  const onCancel = () => {
    setTempValue('');
    togleEditMode(false);
  };

  const onClickUpdate = async () => {
    const confirmation = await confirmWrapper(
      'Are you sure you want to update Job Description?',
      {
        variant: 'warning',
        primaryBtnLabel: 'Proceed',
        secondaryBtnLabel: 'Cancel',
      },
    );

    if (confirmation) {
      try {
        await confirmFunction(tempValue);
        setNewValue(tempValue);
        togleEditMode(false);
      } catch (e) {
        console.log(e);
      }
    }
  };

  const onEdit = () => {
    setTempValue(newValue);
    togleEditMode((prevState) => !prevState);
  };

  return (
    <Box className="relative w-full h-full bg-white p-5 rounded group mb-10">
      {!editMode ? (
        <Box className="w-full h-full">
          <Box className="z-[1] absolute right-5">
            <Box
              className="cursor-pointer group-hover:visible invisible"
              onClick={onEdit}
            >
              <MdEdit size="14" color="#828A97" />
            </Box>
          </Box>
          <Box className="flex">
            <Box className="text-base overflow-hidden text-ellipsis">
              <EditorInline
                value={newValue}
                disabled
              />
            </Box>
          </Box>
        </Box>
      ) : (
        <Box className="relative">
          <Box>
            <EditorInline
              value={tempValue}
              onChange={(e) => {
                setTempValue(e);
              }}
            />
          </Box>
          <Box className="absolute flex gap-[2px] right-0">
            <Box
              className="cursor-pointer"
              onMouseEnter={handleMouseEnterClose}
              onMouseLeave={handleMouseLeaveClose}
              onClick={onCancel}
            >
              {isCloseHovered ? (
                <CloseActiveIcon size={20} />
              ) : (
                <CloseSquareIcon size={20} />
              )}
            </Box>
            <Box
              className="cursor-pointer"
              onMouseEnter={handleMouseEnterConfirm}
              onMouseLeave={handleMouseLeaveConfirm}
              onClick={onClickUpdate}
            >
              {isConfirmHovered ? (
                <ConfirmActiveIcon size={20} />
              ) : (
                <ConfirmSquareIcon size={20} />
              )}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Description;
